module.exports = __webpack_public_path__ + "static/media/2euro.c13c0107.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/2euro.png
// module id = 926
// module chunks = 0